import { render, staticRenderFns } from "./FichasFiltro.vue?vue&type=template&id=06ba5c17&"
import script from "./FichasFiltro.vue?vue&type=script&lang=js&"
export * from "./FichasFiltro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports